import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import HotelsSearch from 'components/HotelsSearch';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const HotelsSearchContainer = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const { travelers, destinationPoint, checkInDate, checkOutDate, branchCompany } = useSelector(
    (state: RootState) => state.hotels,
  );

  return (
    <HotelsSearch
      defaultTravelers={travelers} 
      defaultDestinationPoint={destinationPoint}
      defaultCheckInDate={checkInDate}
      defaultCheckOutDate={checkOutDate}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
    />
  );
};

export default HotelsSearchContainer;
